import MotivationElementNodeType from '../MotivationElementNodeType';
import {MOTIVATION_PRINCIPLE} from '../../metamodel/Concept';

export default class PrincipleNodeType extends MotivationElementNodeType {
	static get typeName() {
		return MOTIVATION_PRINCIPLE;
	}
}
